export const INVALID_DETAIL_TYPES = [
    { value: 'ALL', label: 'All types', icon: 'bi-grid' },
    { value: '1', label: 'Invalid Email', icon: 'bi-envelope-exclamation' },
    { value: '2', label: 'Invalid Cell', icon: 'bi-phone' },
    { value: '3', label: 'Invalid Home', icon: 'bi-telephone-x' },
];

export const INVALID_DETAIL_SORT_FIELDS = [
    { value: 'createdAt', label: 'Created date' },
    { value: 'type', label: 'Type' },
    { value: 'detail', label: 'Detail' },
    { value: 'patient.firstName', label: 'First name' },
    { value: 'patient.lastName', label: 'Last name' },
];

export const DEFAULT_INVALID_DETAIL_FILTERS = {
    patientName: '',
    detail: '',
    type: 'ALL',
    date: '',
    dateFrom: '',
    dateTo: '',
};

export const DEFAULT_INVALID_DETAIL_SORT = {
    sortBy: 'createdAt',
    sortOrder: 'DESC',
};

const appendTextFilter = (parts, field, value, wildcard = true) => {
    const trimmed = value?.trim();
    if (!trimmed) {
        return;
    }
    parts.push(`${field}==${wildcard ? `${trimmed}*` : trimmed}`);
};

const appendContainsFilter = (parts, field, value) => {
    const trimmed = value?.trim();
    if (!trimmed) {
        return;
    }
    parts.push(`${field}==*${trimmed}*`);
};

export const buildInvalidDetailsQuery = (filters, sort = DEFAULT_INVALID_DETAIL_SORT) => {
    const parts = [];

    appendTextFilter(parts, 'patientName', filters.patientName);
    appendContainsFilter(parts, 'detail', filters.detail);

    if (filters.type && filters.type !== 'ALL') {
        parts.push(`type==${filters.type}`);
    }

    if (filters.date) {
        parts.push(`date==${filters.date}`);
    } else {
        if (filters.dateFrom) {
            parts.push(`createdAt=ged=${filters.dateFrom}`);
        }
        if (filters.dateTo) {
            parts.push(`createdAt=led=${filters.dateTo}`);
        }
    }

    if (sort?.sortBy) {
        parts.push(`sortBy==${sort.sortBy}`);
    }

    if (sort?.sortOrder) {
        parts.push(`sortOrder==${sort.sortOrder}`);
    }

    return parts.join(',');
};

export const formatInvalidDetailPatientName = (patient = {}) => {
    const fullName = [patient.firstName, patient.lastName].filter(Boolean).join(' ');

    if (!fullName) {
        return 'Unknown patient';
    }

    if (patient.preferredName) {
        return `${fullName} (${patient.preferredName})`;
    }

    return fullName;
};

export const getInvalidDetailTypeMeta = (type) => {
    switch (Number(type)) {
        case 1:
            return { label: 'Invalid Email', className: 'invalid-detail-type--email', icon: 'bi-envelope-exclamation' };
        case 2:
            return { label: 'Invalid Cell Phone', className: 'invalid-detail-type--cell', icon: 'bi-phone' };
        case 3:
            return { label: 'Invalid Home Phone', className: 'invalid-detail-type--home', icon: 'bi-telephone-x' };
        default:
            return { label: 'Unknown', className: 'invalid-detail-type--unknown', icon: 'bi-question-circle' };
    }
};
